import type { UploadedFileValue } from '~/api/reviews/types/GetReviewCollectionResponse'

async function createFileFromUploadedValue(
  uploadValue: UploadedFileValue,
): Promise<File> {
  const response = await fetch(uploadValue.url)
  const blob = await response.blob()

  return new File([blob], uploadValue.fileName, { type: blob.type })
}

export async function convertUploadedValuesToFiles(
  uploadValues: UploadedFileValue[],
): Promise<File[]> {
  const filteredUploadValues = uploadValues.filter(({ url }) => !!url)

  const files = await Promise.all(
    filteredUploadValues.map(
      async (uploadValue) => await createFileFromUploadedValue(uploadValue),
    ),
  )

  return files
}
